import { mdiChevronDown, mdiChevronLeft, mdiChevronRight, mdiChevronUp, mdiChartTree, mdiStar, mdiStarOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { getTextLang, LanguageContext } from '../components/providers/LanguageProvider';
import { Button, Card, Container, ContainerFlex, TextLocalized, Tooltip } from '../components/styled/Styled';
import { CategoryIndexAction, CategoryIndexContext } from '../components/providers/CategoryIndexProvider';
import { HttpConnection, HttpOperations, HttpMethod } from '../components/util/HttpConnection';
import { getBlockImage } from '../components/util/BlockUtil';
import { UserAction, UserContext } from '../components/providers/UserProvider';
import { QuizProvider, useQuiz } from '../components/providers/QuizProvider';

const SingleAnswer = ({ item }) => {
    const { dispatch } = useQuiz();
    const { language } = useContext(LanguageContext);

    const onChange = (e) => {
        const answerId = parseInt(e.target.value);

        // Actualizar el estado global
        dispatch({
            type: 'UPDATE_ANSWER',
            payload: {
                questionId: item.id_question,
                answerId: answerId
            }
        });

        // Enviar al servidor
        HttpConnection(`${HttpOperations.useranswer}/${answerId}`,
            response => console.log("Success"),
            error => console.log(error),
            HttpMethod.post
        );
    };

    return (
        <Container width="12" ph="8" pv="16" fontColor="color-black">
            {item.answers.map(answer => (
                <ContainerFlex key={answer.id_answer} width="12" mv="16" align="center" multiline={false}>
                    <input
                        type="radio"
                        checked={answer.user_answer != null || (answer?.selected ?? false)}
                        onChange={onChange}
                        id={answer.id_answer}
                        value={answer.id_answer}
                        name={item.id_question}
                    />
                    <Container ml="8">
                        <label htmlFor={answer.id_answer}>{getTextLang(answer, 'description', language)}</label>
                    </Container>
                </ContainerFlex>
            ))}
        </Container>
    );
};

const QuizItem = ({ item }) => {
    const { language } = useContext(LanguageContext);

    return <Card width="12" shadowOn mv="16" color={"color-white"}>
        <Card px="16" radiusbl="0px" radiusbr="0px" color="color-gray-card" width="12" fontSize="16px" fontWeight="300" fontColor="color-black"
            children={getTextLang(item, 'description', language)} />
        <Container width="12" height="1px" color="color-gray" />
        <SingleAnswer item={item} />
    </Card>
}

const CategoryGroup = ({ group }) => {

    const languageText = useContext(LanguageContext);
    const { state, dispatch } = useQuiz();

    const userContext = useContext(UserContext);
    const categoryContext = useContext(CategoryIndexContext);

    useEffect(() => {
        if (categoryContext.state.index === group.id_group && group.info === null) {
            const updatedGroup = {
                ...group,
                info: {
                    comment: "",
                    important: false,
                    open: true,
                }
            };
            //Send to server
            HttpConnection(`${HttpOperations.groupinfo}/${group.id_group}`,
                response => {
                    dispatch({
                        type: 'UPDATE_COMMENT',
                        payload: {
                            groupId: group.id_group,
                            info: updatedGroup.info
                        }
                    });
                },
                error => console.log(error), HttpMethod.post, updatedGroup.info);
        }
    }, [state.index])

    const changeLevel = (e) => {
        e.stopPropagation();
        const updatedGroup = {
            ...group,
            info: {
                ...group.info,
                important: !group.info?.important
            }
        };

        // Enviar al servidor
        HttpConnection(`${HttpOperations.groupinfo}/${group.id_group}`,
            response => {
                dispatch({
                    type: 'UPDATE_INFO',
                    payload: {
                        groupId: group.id_group,
                        info: updatedGroup.info
                    }
                });
            },
            error => console.log(error),
            HttpMethod.post,
            updatedGroup.info
        );
    };

    const changeInfo = (e) => {
        dispatch({
            type: 'UPDATE_INFO',
            payload: {
                groupId: group.id_group,
                info: {
                    ...group.info,
                    comment: e.target.value
                }
            }
        });
    }

    const saveComment = (e) => {
        e.stopPropagation();
        //Send to server
        HttpConnection(`${HttpOperations.groupinfo}/${group.id_group}`,
            response => {
                userContext.dispatch({ action: UserAction.showNoti, data: { show: true, color: "color-green", message: "msgSuccess" } });
            }, error => console.log(error), HttpMethod.post, group.info);
    }

    const actionNext = () => {
        categoryContext.dispatch({ action: CategoryIndexAction.next, data: group.id_group })
    }

    const actionToggle = () => {
        categoryContext.dispatch({ action: CategoryIndexAction.setIndex, data: group.id_group })
    }

    return <Card shadowOn width="12" mt="16" color="color-white" overflow="visible">
        <Button overflow="visible" onClick={actionToggle} flex width="12" px="16" align="center" color={state.index === group.id_group ? "color-gray-card" : ""} radiusbl="0px" radiusbr="0px">
            <Container width="wrap" fontSize="16px" fontWeight="300" fontColor="color-black" children={getTextLang(group, 'name', languageText.language)} />
            <Button title={languageText.dictionary["msgMarkImportant"]} onClick={changeLevel} mh="16" ph="8" fontColor="color-black">
                <Icon path={group.info && group.info.important == true ? mdiStar : mdiStarOutline} size={1} />
            </Button>
            <Container maxheight="24px" children={<Icon size={1} path={state.index === group.id_group ? mdiChevronUp : mdiChevronDown} />} />
        </Button>

        {
            categoryContext.state.index === group.id_group ? <>
                <Container width="12" height="1px" color="color-gray" />
                <ContainerFlex width="12" pv="16" ph="32" mb="32">

                    {group.questions.map((question) => <QuizItem key={question.id_question} item={question} />)}

                    <Card shadowOn width="12" mt="16" color={"color-white"}>
                        <Card px="16" radiusbl="0px" radiusbr="0px" color="color-gray-card" width="12" fontSize="16px" fontWeight="300" fontColor="color-black" children={<TextLocalized children="msgComment" />} />
                        <Container width="12" height="1px" color="color-gray" />
                        <ContainerFlex width="12" align="center">
                            <Container width="wrap" px="16" children={<input onChange={changeInfo} value={group.info && group.info.comment ? group.info.comment : ""} placeholder={languageText.dictionary["msgCommentHolder"]} type="text" />} />
                            <Button title={languageText.dictionary['msgSaveCommentAlt']} mh="8" onClick={saveComment} pv="8" ph="16" fontColor="color-white" color="color-green-dark" hoverColor="color-black" children={<TextLocalized children="actionSave" />} />
                        </ContainerFlex>
                    </Card>
                    <ContainerFlex width="12" mt="32" justify="flex-end" fontColor="color-white">
                        <Button onClick={actionNext} pv="8" ph="16" color="color-green-dark" hoverColor="color-black" children={<TextLocalized children="actionNext" />} />
                    </ContainerFlex>
                </ContainerFlex>

            </> : null
        }
    </Card>
}

const AssessmentSection = () => {
    const [blocks, setBlocks] = useState([]);
    const [index, setIndex] = useState();

    const { language } = useContext(LanguageContext);
    const categoryContext = useContext(CategoryIndexContext);
    const { state, dispatch } = useQuiz();

    let history = useNavigate();
    let location = useLocation();

    useEffect(() => {
        HttpConnection(HttpOperations.block, response => {
            //Set blocks
            setBlocks(response.item);
            setIndex(response.item.findIndex(block => block.id_block === location.state.item.id_block));
        }, error => console.log(error), HttpMethod.get);
    }, [location.state.item?.id_block])

    useEffect(() => {
        if (index != null) {
            HttpConnection(`${HttpOperations.block}/${blocks[index].id_block}`,
                response => {
                    categoryContext.dispatch({ action: CategoryIndexAction.setCategories, data: response.item.groups });
                    dispatch({ type: 'SET_INITIAL_DATA', payload: response.item });
                }, error => console.log(error), HttpMethod.get);
        }
    }, [index, blocks, dispatch])

    const nextBlock = (page) => {
        setIndex(index + page);
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return state ? <ContainerFlex width="12" justify="center">
        <ContainerFlex width="12" lg="8" xl="8" justify="center" >
            <Card flex shadowOn color="color-white" width="12" mt="32" align="stretch">
                <Card flex px="16" color="color-green-a40" justify="center" align="center" width="250px" radiusbr="0" radiustr="0" minheight="100%" >
                    <img alt={`block-${state.id_block}`} height="200px" width="100%" src={getBlockImage(state)} />
                </Card>

                <Container width="wrap" ph="8">
                    <Container width="12" ph="8" pv="8" fontColor="color-gray-dark" children={<TextLocalized children={state.id_block != 1 ? "msgBlockArea" : "msgBlockValues"} />} />
                    <Container width="12" ph="8" fontSize="18px" fontWeight="bold" children={getTextLang(state, 'name', language)} />
                    <Container width="12" ph="8" pv="16" fontSize="14px" dangerouslySetInnerHTML={{ __html: getTextLang(state, 'description_long', language) }} />
                </Container>
            </Card>

            <Card width="12" shadowOn flex mt="32" px="16" justify="center" color="color-green-dark" fontColor="color-white">
                <Container fontSize="13px" children={<TextLocalized children="msgNotApply" />} />
            </Card>

            <ContainerFlex width="12">
                {
                    state.groups.map((group) => <CategoryGroup key={group.id_group} group={group} />)
                }
            </ContainerFlex>

            <ContainerFlex width="12" justify="space-around">
                {
                    index > 0 ?
                        <ContainerFlex fontColor="color-black" align="center" pv="32">
                            <Button onClick={() => nextBlock(-1)} flex justify="center" pr="16" align="center" fontWeight="bold" color="color-green-dark" hoverColor="color-black" fontColor="color-white">
                                <Icon path={mdiChevronLeft} size={2} />
                                <label children={getTextLang(blocks[index - 1], "name", language)} />
                            </Button>
                        </ContainerFlex>
                        : null
                }
                {
                    index < blocks.length - 1 ?
                        <ContainerFlex fontColor="color-black" align="center" pv="32">
                            <Button onClick={() => nextBlock(1)} flex justify="center" pl="16" align="center" fontWeight="bold" color="color-green-dark" hoverColor="color-black" fontColor="color-white">
                                <label children={getTextLang(blocks[index + 1], "name", language)} />
                                <Icon path={mdiChevronRight} size={2} />
                            </Button>
                        </ContainerFlex>
                        :
                        <ContainerFlex fontColor="color-black" align="center" pv="32">
                            <Button onClick={() => history("/performance")} flex justify="center" pl="16" align="center" fontWeight="bold" color="color-green-dark" hoverColor="color-black" fontColor="color-white">
                                <label children={<TextLocalized children={"actionDoDiagnost"} />} />
                                <ContainerFlex px="12" children={<Icon path={mdiChartTree} size={1} />} />
                            </Button>
                        </ContainerFlex>
                }
            </ContainerFlex>
        </ContainerFlex>
    </ContainerFlex>
        : null
};

const AssessmentSectionView = () => {
    return <QuizProvider initialData={null}>
        <AssessmentSection />
    </QuizProvider>
}

export default AssessmentSectionView;